// stores/menus.js
import { defineStore } from "pinia";
import { ref } from "vue";
import { useRuntimeConfig } from "#app";
import { useI18n } from "vue-i18n";

export const useMenusStore = defineStore(
  "menus",
  () => {
    const menu = ref(null);
    const error = ref(null);

    // Getting baseApi from runtime config (server-safe)
    const config = useRuntimeConfig();
    const { baseApi } = useApiBase();
    const appApi = config.public.appApi;

    // Getting locale from i18n
    const { locale } = useI18n();

    const fetchMenu = async (path = null) => {
      let apiUrl = `${baseApi}/${locale.value}/menus`;

      if (path != null) {
        apiUrl = `${apiUrl}${path}`;
      }

      try {
        const response = await $fetch(apiUrl);
        menu.value = response.data;
      } catch (fetchError) {
        console.error("Error fetching menu data:", fetchError);
        error.value = fetchError;
      }
    };

    const searchMenu = async (path = null) => {

      const apiUrl = `${appApi}/${locale.value}/menus/main`;

      try {
        const response = await $fetch(apiUrl);
        const items = response.data; // Assuming `data` is the full menu structure.

        const findItem = (menuItems, urlToFind) => {
          for (const item of menuItems) {
            if (item.url === urlToFind) {
              return item; // Found the matching item
            }
            if (item.children && item.children.length > 0) {
              const foundInChild = findItem(item.children, urlToFind);
              if (foundInChild) {
                return foundInChild; // Found in children
              }
            }
          }
          return null; // Not found
        };

        // Search for the item with the URL path
        const result = findItem(items, path);

        if (result) {
          menu.value = result;
        } else {
          console.warn("Menu item with the specified URL not found.");
          menu.value = null;
        }
      } catch (fetchError) {
        console.error("Error fetching menu data:", fetchError);
        error.value = fetchError;
      }
    };

    return {
      menu,
      error,
      fetchMenu,
      searchMenu,
    };
  },
  {
    persist: {
      enabled: true,
    },
  }
);
